import React, { useState, useRef, useEffect } from 'react';
import {API, Auth} from 'aws-amplify';
import DesmosCalculator from "./desmosCalculator";
import {
    createDesmomathslide,
    updatePlayslide
} from "../../graphql/mutations";
import Resizer from "react-image-file-resizer";
import {getPlayslide} from "../../graphql/queries";
import {v4 as uuid} from "uuid";
import Grid from "@material-ui/core/Grid";

const resizeFile = (file) =>
    new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            960,
            540,
            "JPEG",
            85,
            0,
            (uri) => {
                resolve(uri);
            },
            "base64"
        );
    });
const resizeFile1 = (file) =>
    new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            400,
            400,
            "JPEG",
            85,
            0,
            (uri) => {
                resolve(uri);
            },
            "base64"
        );
    });
const  Createmathslide = ({id, handleClose65})  =>{
    const addRef = useRef(null);
    const [isUser, setIsUser] = useState(false);
    const [isOwner, setIsOwner] = useState(false);
    const [images, setImages] = useState([]);
    const [selectedFile, setSelectedFile] = useState("");
    const [smessage, setSmessage] = useState("")
    const [opensmessage, setOpensmessage] = useState(true)
    const d = uuid();
    useEffect( () => {
        Auth.currentAuthenticatedUser()
            .then(user => (setIsUser(user.attributes.email)))
            .catch(err => console.log(err));
        (async() => {
            const response = await API.graphql({
                query: getPlayslide,
                variables:{id}
            })
            const datas = response.data.getPlayslide;
            const iowner = datas.owner;
            setIsOwner(iowner);
            const images = datas.playlistlinks;
            if(images != null) {
                setImages(images);
            }
        })()
    }, []);

    const handleFileChange = async (event) => {
        const img = event.target.files[0];
        const resized = await resizeFile1(img);
        setSelectedFile(resized)
    };
    const reorderurl = `https://edu.reachum.com/mathslideshow/${id}/${d}`;
    const erurl = `https://edu.reachum.com/editmathslide/${id}/${d}`;

 async function savethis(){
     const calculatorState = addRef.current.getState()
     const latexExpressions = calculatorState.expressions.list.filter(expression => {
         return expression.latex != null
     })
     let resized;
     if (latexExpressions.length === 0) {
         resized = "";
     } else {
         const screenshot = addRef.current.screenshot()
         const response = await fetch(screenshot)
         const blob = await response.blob()
         resized = await resizeFile(blob)
     }
     try {
         const input = {
             id:d,
             graphic:resized,
             image:selectedFile
         }
         await API.graphql({
             query: createDesmomathslide,
             variables: {input}
         });
         const urldata = {
             rid:d,
             title:"math slide",
             rurl: reorderurl,
             eurl:erurl
         };
         const allImages = [...images, urldata]
         const inputs = {
             id,
             playlistlinks: allImages
         }
         await API.graphql({
             query: updatePlayslide,
             variables: {input:inputs}
         })
         setOpensmessage(false);
         setSmessage("Submitted");
         setTimeout(() => {
             handleClose65()
         }, 1000)
     } catch (err) {
         console.log(err)
     }
}

    return (
        <>
            {isOwner === isUser ?
            <>
                <div className="slidepage">
                    <div className="thiscenter">
                        <h3>Math slide</h3>
                    </div>
                </div>
                <br/>
            <div className="mathslidepage">
                <Grid container spacing={0}>
                    <Grid item xs={3} className="rightside">
                        <p>Upload image: (option) &nbsp;</p>
                    </Grid>
                    <Grid item xs={9} className="leftside">
                        <input type="file" onChange={handleFileChange} />
                    </Grid>
                </Grid>
                <br/>
                <div className="mathcccenter">
                <img src={selectedFile} className="pximages400" />
                </div>
                <br/>
                <p>Graphing Calculator: (<span onClick={()=>  window.open("https://www.desmos.com/", "_blank")} className="underlinetext"> Desmos </span>) <span className="redthis">( Once submitted, you won't be able to make changes to the graphics.) </span></p>
                <DesmosCalculator ref={addRef} />
                <br/>
                <br/>
                <Grid container spacing={0}>
                    <Grid item xs={10} className="rightside">
                        {opensmessage ?
                <button onClick={savethis} className="answersubmit">Submit</button>
                            :
                            <p className="redthis"> {smessage} </p>
                        }
                    </Grid>
                    <Grid item xs={2} className="rightside">
                    </Grid>
                </Grid>

                <br/>
                <br/>
            </div>
              </>
                    :""
            }
            </>
    );
}

export default Createmathslide;
